<template>
  <div v-if="graphItems.length > 0" class="graph-table-container">
    <PieGraphTable
      :id="id"
      :items="graphItems"
      class="sidebar-graph-table"
      :show-percentages="true"
      :story-colour="storyColour"
    />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import PieGraphTable from '@/components/public/GraphTable/PieGraphTable.vue'
import { GraphItem } from '@/components/public/GraphTable/types'
import { VisNode } from '@/types'

const components = {
  PieGraphTable,
}

const props = {
  id: {
    type: String,
    default: 'popup-pie-graph-table',
  },
  node: {
    type: Object as PropType<VisNode | undefined>,
    required: true,
  },
  storyColour: {
    type: String,
    required: false,
  },
}

@Component({ components })
export default class PopupPieGraphTable extends Vue.extend({ props }) {
  get formatValueByColumn() {
    return this.$typedStore.visualisationData.formatValueByColumn
  }

  get name() {
    return this.$typedStore.visualisationApp.name
  }

  get piechartItems() {
    return this.$typedStore.visualisationApp.piechartItems
  }

  get total() {
    return this.piechartItems.reduce((acc, cur) => {
      return acc + this.nodeDataValueForColumn(cur.column)
    }, 0)
  }

  get graphItems(): GraphItem[] {
    return this.piechartItems.map(({ column, color }) => {
      const title = this.name(column)
      const value = this.nodeDataValueForColumn(column)
      const formatted = this.formatValueByColumn(column, value)
      return {
        title,
        value,
        formatted,
        color,
        percentage: this.total === 0 ? 0 : value / this.total,
      }
    })
  }

  nodeDataValueForColumn(column: string) {
    return this.node ? Number(this.node.data[column]) : 0
  }
}
</script>

<style scoped>
.total {
  color: #455;
}
</style>
